import * as React from 'react';
import { SVGProps } from 'react';

const FileIconRtfSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 34 40" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M31.733 0H2.267C1.015 0 0 .895 0 2v36c0 1.105 1.015 2 2.267 2h29.466C32.985 40 34 39.105 34 38V2c0-1.105-1.015-2-2.267-2Z" />
    <path
      opacity={0.6}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 20h18v-1H8v1Zm0 4h18v-1H8v1Zm18 4H8v-1h18v1ZM8 32h9v-1H8v1Z"
      fill="#fff"
    />
    <path
      d="M22.35 6a.374.374 0 0 0-.26.09.268.268 0 0 0-.09.21V7h1v1h-1v3h1v1h-3v-1h1V8h-1V7h1v-.9c0-.34.097-.607.29-.8.193-.2.443-.3.75-.3H24v1h-1.65ZM17.05 12c-.34 0-.6-.11-.78-.33-.18-.22-.27-.51-.27-.87V8h-1V7h1V6h1v1h2v1h-2v2.6c0 .147.037.25.11.31.073.06.187.09.34.09H19v1h-1.95ZM11 8.01V11h-1v1h3v-1h-1V8.62a.708.708 0 0 1 .17-.41c.107-.14.267-.21.48-.21H14V7h-2c-.313 0-.78.32-1 .5V7h-1v1.01h1Z"
      fill="#fff"
    />
  </svg>
);
export default FileIconRtfSizeM;
